import { render, staticRenderFns } from "./HRPostItemMobile.vue?vue&type=template&id=28f1493e&scoped=true&"
import script from "./HRPostItemMobile.vue?vue&type=script&lang=js&"
export * from "./HRPostItemMobile.vue?vue&type=script&lang=js&"
import style0 from "./HRPostItemMobile.vue?vue&type=style&index=0&id=28f1493e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1493e",
  null
  
)

export default component.exports